import { MpProduct } from "@bookingcom/mp-flights";
import { UIOrderExtras } from "@flights/types";

export const transfromMultiProductsToOrderExtras = (multiProducts?: MpProduct[]): UIOrderExtras => {
  const ancillaries: UIOrderExtras = {};

  if (!multiProducts || multiProducts.length === 0) return ancillaries;

  multiProducts.forEach((multiProduct) => {
    switch (multiProduct.productType) {
      case "INSURANCE":
        ancillaries.travelInsurance = {
          reference: "",
          price: multiProduct.priceBreakdown,
          travelerPrices: [],
          documents: {},
          isPerTraveller: false,
          version: 0
        };
        break;
      default:
        break;
    }
  });

  return ancillaries;
};
